export function ApiLoginUser(body, callback) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: body
    };

    fetch(process.env.REACT_APP_CMS_URL + '/api/login', requestOptions)
        .then(response => response.json())
        .then(data => {
            callback?.(data);
        });
}

export function ApiLoginGuest(body, callback) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: body
    };

    fetch(process.env.REACT_APP_CMS_URL + '/api/loginGuest', requestOptions)
        .then(response => response.json())
        .then(data => {
            callback?.(data);
        });
}

export function ApiGetRegisterStatus(body, callback) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: body
    };

    fetch(process.env.REACT_APP_CMS_URL + '/api/getRegisterStatus', requestOptions)
        .then(response => response.json())
        .then(data => {
            callback?.(data);
        });
}

export function ApiRegisterDevice(body, callback) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: body
    };

    fetch(process.env.REACT_APP_CMS_URL + '/api/registerDevice', requestOptions)
        .then(response => response.json())
        .then(data => {
            callback?.(data);
        });
}

export function ApiLoginConfigUser(body, callback) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: body
    };

    fetch(process.env.REACT_APP_CMS_URL + '/api/loginConfig', requestOptions)
        .then(response => response.json())
        .then(data => {
            callback?.(data);
        });
}

export function ApiLoginMobileUser(body, callback) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: body
    };

    fetch(process.env.REACT_APP_CMS_URL + '/api/loginMobile', requestOptions)
        .then(response => response.json())
        .then(data => {
            callback?.(data);
        });
}







